import { logger } from '@origin-digital/reporting-client';
import { get } from 'lodash';
import { IContent, LoginError, Severity } from '../../login/interfaces';
import { getForgotPasswordUrl } from '../../login/services/urlService';
import { getDeviceId } from '../../url/UrlUtils';

const content: IContent = require('../../../ts/content.json');

const handleLoginError = (errorCode: string, usernameOrState: string): LoginError => {
  // too much noise in logs for invalid user password
  if (errorCode !== 'invalid_user_password') {
    const deviceId = getDeviceId();
    logger.error(
      `handleError invoked ${usernameOrState} with errorCode: ${errorCode} and uniqueId: ${deviceId}`,
      new Error(`${usernameOrState}:  errorCode: ${errorCode}, uniqueId: ${deviceId}`),
    );
  }

  const error = get(content.login_errors, errorCode, content.login_errors.generic_error);
  if (errorCode === 'invalid_user_password') {
    return {
      passwordError: true,
    };
  } else if (error.severity === Severity.CRITICAL) {
    return {
      navigateToErrorPage: true,
    };
  } else {
    // not an ideal solution for setting links from json, should refactor to
    // something better
    if (errorCode === 'too_many_attempts') {
      error.body = error.body.replace('[link]', getForgotPasswordUrl());
    }
    return {
      alertError: error,
    };
  }
};

export { handleLoginError };
